export class AuthToken {
  public constructor(public readonly token: string) {}
}
